import "core-js/modules/es6.promise";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import listMixin from '@/components/niotaClassic/listMixin';
import { userItemsPerListMixin, isCopyToClipboardSupported, copyToClipboard as _copyToClipboard } from '@/utils/vuex';
import get from 'lodash/get';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicesListsList',
  mixins: [listMixin, userItemsPerListMixin],
  props: {
    selectedAccounts: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function data() {
    return {
      lastSearch: '',
      isInitialSearch: false,
      disableFetchOnCreatedMixin: true,
      tableOptions: _objectSpread({}, defaultTableOptions),
      selected: [],
      deleteFromActility: false,
      isActility: false,
      device: null,
      operationalStatus: {
        0: this.$i18n_t('NiotaClassic.Devices.form.unset'),
        1: this.$i18n_t('NiotaClassic.Devices.form.inTransit'),
        2: this.$i18n_t('NiotaClassic.Devices.form.readyForOperation'),
        3: this.$i18n_t('NiotaClassic.Devices.form.inOperation'),
        4: this.$i18n_t('NiotaClassic.Devices.form.temporaryInactive'),
        5: this.$i18n_t('NiotaClassic.Devices.form.decommissioned')
      },
      expanded: []
    };
  },
  computed: {
    tableLocalizations: function tableLocalizations() {
      return {
        headers: [{
          text: this.$i18n_t('NiotaClassic.Common.table.id'),
          value: 'id',
          align: 'right',
          width: 70
        }, {
          text: '',
          value: 'image',
          sortable: false,
          width: 40
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.table.name'),
          value: 'title'
        }, {
          text: this.$i18n_t('NiotaClassic.Common.table.eui'),
          value: 'eui'
        }, {
          text: this.$i18n_t('NiotaClassic.Devices.table.originator'),
          value: 'originator'
        }, // {
        //   text: this.$i18n_t('NiotaClassic.Devices.table.application'),
        //   value: 'application',
        // },
        // {
        //   text: this.$i18n_t('NiotaClassic.Devices.table.threshold'),
        //   value: 'threshold',
        // },
        {
          text: this.$i18n_t('NiotaClassic.Devices.table.operationalStatus'),
          value: 'operationalStatus'
        }, // {
        //   text: this.$i18n_t('NiotaClassic.Common.table.createdAt'),
        //   value: 'createdAt',
        // },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '78'
        }],
        tableFooterProps: {
          itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
          itemsPerPageOptions: [10, defaultItemsPerPage, 20, 50]
        }
      };
    }
  },
  watch: {
    selectedAccounts: debounce(function () {
      // Items have already been requested
      if (this.isFetching) {
        return;
      }

      this.fetchList();
      this.updateAccountParams();
    }, 500)
  },
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
    var page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    var perPage = parseInt(this.$route.query.perPage, 10) || defaultTableOptions.itemsPerPage;
    var search = this.$route.query.search || '';

    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }

    this.tableOptions.page = page;
    this.tableOptions.itemsPerPage = perPage;
  },
  methods: {
    updatePagination: function updatePagination(e) {
      this.$router.replace({
        query: _objectSpread(_objectSpread(_objectSpread({}, this.$route.query), {
          page: e.page || defaultTableOptions.page
        }), {
          perPage: e.itemsPerPage || defaultTableOptions.itemsPerPage
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateAccountParams: function updateAccountParams() {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          accounts: this.getAccountIds(this.selectedAccounts).join(',') || undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    updateSearchParams: function updateSearchParams(searchTerm) {
      this.$router.replace({
        query: _objectSpread(_objectSpread({}, this.$route.query), {
          search: searchTerm || undefined
        })
      }).catch(function (error) {
        console.error(error);
      });
    },
    fetchList: function fetchList() {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.isFetching = true;
      var trimmedSearch = (this.searchItem || '').trim();

      if (this.lastSearch !== trimmedSearch) {
        this.selected = [];
        this.lastSearch = trimmedSearch;

        if (!this.isInitialSearch) {
          this.tableOptions = _objectSpread(_objectSpread({}, this.tableOptions), {}, {
            page: 1
          });
        }

        this.isInitialSearch = false;
      }

      var _this$tableOptions = this.tableOptions,
          sortBy = _this$tableOptions.sortBy,
          sortDesc = _this$tableOptions.sortDesc,
          page = _this$tableOptions.page,
          itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'createdAt';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = Math.max(1, page || 1);
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      var promise = undefined;

      if (trimmedSearch) {
        this.updateSearchParams(trimmedSearch);

        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.devicesFind(trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.devicesFindByAccount(this.getAccountIds(this.selectedAccounts), trimmedSearch, usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      } else {
        this.updateSearchParams('');

        if (!this.selectedAccounts.length) {
          promise = NiotaClassicApiService.devicesFetch(usedPage, usedItemsPerPage, sortItem, sortDirection);
        } else {
          promise = NiotaClassicApiService.devicesFetchByAccount(this.getAccountIds(this.selectedAccounts), usedPage, usedItemsPerPage, sortItem, sortDirection);
        }
      }

      promise.then(function (res) {
        _this.list = res.data.devices;
        _this.serverItemsLength = res.pagination.itemCount;
      }).catch(function (error) {
        console.error('Error fetching devices', error);
      }).finally(function () {
        _this.isFetching = false;
      });
    },
    enterSelect: function enterSelect(rows) {
      this.$emit('enterSelect', rows);
    },
    handleClickDevice: function handleClickDevice(item) {
      this.$router.push("/niota-classic/devices/".concat(item.id, "/details"));
    },
    deleteFromRemote: function deleteFromRemote(remove) {
      this.deleteFromActility = remove;
    },
    showDeletePrompt: function () {
      var _showDeletePrompt = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchDevice(item.id);

              case 2:
                this.selectedItem = item;
                this.deletePrompt = true;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function showDeletePrompt(_x) {
        return _showDeletePrompt.apply(this, arguments);
      }

      return showDeletePrompt;
    }(),

    /** closeDeletePrompt in listMixin */
    deletePromise: function deletePromise() {
      if (this.deleteFromActility) {
        return NiotaClassicApiService.deviceDeleteFromActility(this.selectedItem.id);
      } else {
        return NiotaClassicApiService.deviceDelete(this.selectedItem);
      }
    },
    fetchDevice: function fetchDevice(id) {
      var _this2 = this;

      return NiotaClassicApiService.deviceGetDetails(id).then(function (res) {
        _this2.device = res.data.device;
        _this2.isActility = (get(_this2.device, 'originator.type') || '').toLowerCase() === 'actility';
      }).catch(function () {
        _this2.device = null;

        _this2.$snack(_this2.$i18n_t('NiotaClassic.Devices.snacks.notFound'), 'error');
      });
    },
    isCopySupported: function isCopySupported() {
      return isCopyToClipboardSupported();
    },
    copyToClipboard: function copyToClipboard(event, copyValue) {
      event.stopPropagation();

      _copyToClipboard(copyValue);
    },
    getStatus: function getStatus(status) {
      return this.operationalStatus[status.value];
    },
    getAccountIds: function getAccountIds(accounts) {
      var ids = [];
      accounts.forEach(function (account) {
        ids.push(account.id);
      });
      return ids;
    },
    setCurrentTablePage: function setCurrentTablePage(value) {
      this.tableOptions.page = value;
    }
  }
};